import { render, staticRenderFns } from "./oilAppointHistory.vue?vue&type=template&id=4f513a6a&scoped=true"
import script from "./oilAppointHistory.vue?vue&type=script&lang=js"
export * from "./oilAppointHistory.vue?vue&type=script&lang=js"
import style0 from "./oilAppointHistory.vue?vue&type=style&index=0&id=4f513a6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f513a6a",
  null
  
)

export default component.exports